import React, { useEffect, useState } from "react";
import { Form, message, Space, Divider, Row, Col, Skeleton, Tooltip } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, TableComponent, ButtonComponent, SelectWithSearch, trans, InputTime, InputDate } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const } from "../../constants";
import { dateOptionsReq, getPreviewQueryReq, getReportTypesAndTables, getSchedulerResourceReq, getTableInfoByIdReq, saveScheduleReportReq, updateDataReq } from "../requests";
import { createSelectList } from '@comps/commonFunctions';
import { PlayArrowOutlined } from "@mui/icons-material";
import { convertTimeTotz } from "../../../../wrappers/commonFunctions";
import dayjs from "dayjs";
const langKey = Const["allReports"].lngKey
const formName = "createRawReport";

const ScheduleReport = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [schedulers, setSchedulers] = useState([]);
  const [allTables, setAllTables] = useState('')
  const [tables, setTables] = useState([])
  const [columns, setColumns] = useState([])
  const [queryResultTable, setQueryResultTable] = useState(null)
  const [queryError, setQueryError] = useState('')
  const [selectedTableId, setSelectedTableId] = useState(null)
  const [emailReciver, setEmailReciver] = useState('')
  const [running, setRunning] = useState(false)
  let [tempQuery, setTempQuery] = useState('')
  const [dateOptions, setDateOptions] = useState([])
  const [directiveFilters, setDirectiveFilters] = useState([]);
  const [frequency, setFrequency] = useState();

  const [form] = Form.useForm()

  var description = '';
  const emailRecievers = [
    {
      "value": "manual",
      "label": "Manual"
    },
    // {
    //   "value": "all_employees",
    //   "label": "All Employees"
    // },
    // {
    //   "value": "relevant_data",
    //   "label": "Everyone with their data"
    // }
  ]

  const frequencyOptions = [

    {
      "value": "daily",
      "label": "Daily"
    },
    {
      "value": "weekly",
      "label": "Weekly"
    },
    {
      "value": "monthly",
      "label": "Monthly"
    },
    // {
    //   "value": "yearly",
    //   "label": "Yearly"
    // },
    {
      "value": "custom",
      "label": "Custom"
    }

  ]

  const days = [
    {
      "value": "Monday",
      "label": "Monday"
    },
    {
      "value": "Muesday",
      "label": "Tuesday"
    },
    {
      "value": "Wednesday",
      "label": "Wednesday"
    },
    {
      "value": "Thursday",
      "label": "Thursday"
    },
    {
      "value": "Friday",
      "label": "Friday"
    },
    {
      "value": "Saturday",
      "label": "Saturday"
    },
    {
      "value": "Sunday",
      "label": "Sunday"
    }
  ]


  useEffect(() => {
    // getRelatedData()
    setData()
    //getDateOptions()
    // eslint-disable-next-line
  }, []);

  const setData = () => {
    setDirectiveFilters(props.record.directive_filters || [])
    if (props.record.report_schedule.length > 0) {
      if (props.record.report_schedule[0].time_of_day) {
        props.record.report_schedule[0].time_of_day = convertTimeTotz(props.record.report_schedule[0].time_of_day)
      }
      if (props.record.report_schedule[0].next_run_at) {
        props.record.report_schedule[0].next_run_at = convertTimeTotz(props.record.report_schedule[0].next_run_at)
      }
      if (props.record.report_schedule[0].last_run_at) {
        props.record.report_schedule[0].last_run_at = convertTimeTotz(props.record.report_schedule[0].last_run_at)
      }
      form.setFieldsValue(props.record.report_schedule[0])
      setEmailReciver(props.record.report_schedule[0].email_receiver)
      setFrequency(props.record.report_schedule[0].frequency)
      description = props.record.report_schedule[0].description || '';

    }

    setLoading(false)
  }
  //get report types and tables
  const getRelatedData = () => {
    makeRequestStateless(getSchedulerResourceReq, null, onSuccessRelatedData, null);
  }
  const getDateOptions = () => {
    makeRequestStateless(dateOptionsReq, null, onGetDateOptions, null);
  }


  const onSuccessRelatedData = (data) => {
    setSchedulers(createSelectList(data))
    setLoading(false)
  }
  const onGetDateOptions = (data) => {

    setDateOptions(data.resources)
    setLoading(false)
  }

  const onSubmit = (data) => {
    data.report_id = props.record.id
    delete data.next_run_at
    delete data.last_run_at

    let scheduleData = {
      report_id: data.report_id,
      file_type: data.file_type,
      email_receiver: data.email_receiver,
      email_to: data.email_to,
      email_cc: data.email_cc,
      frequency: data.frequency,
      day_of_week: data.day_of_week,
      day_of_month: data.day_of_month,
      time_of_day: data.time_of_day,
      custom_cron_expression: data.custom_cron_expression,
      status: data.status
    }

    const payload = { report_schedule: scheduleData }
    payload.id = props.record.id
    makeRequest(setLoader, saveScheduleReportReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    message.success("Saved Successfully");
    props.onCompleted(data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }



  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    !props.disabled &&
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1400 } maskClosable={ false }
      mainTitle={ 'Schedule' } subTitle={ "Report" }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>


        <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } disabled={ props.disabled }>
          <Row gutter={ 30 }>

            {
              <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                <Form.Item name="description" label={ trans(`${langKey}.description`) }
                  initialValue={ description }
                >
                  <InputTextArea value={ description } disabled />
                </Form.Item>
              </Col>
            }
            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="title" rules={ rules.name } label={ trans(`${langKey}.name`) }
                initialValue={ props.record.title || '' }
              >
                <InputText placeholder="Name" disabled />
              </Form.Item>


            </Col>
            {/* <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="scheduled_ids" label={ trans(`${langKey}.scheduled_ids`) } rules={ rules.scheduled_ids }

              >
                <SelectWithSearch

                  placeholder={ trans(`${langKey}.scheduled_ids`) }
                  options={ schedulers } />
              </Form.Item>

            </Col> */}
            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="file_type" label={ trans(`${langKey}.file_type`) } rules={ rules.file_type }

              >
                <SelectWithSearch

                  placeholder={ trans(`${langKey}.file_type`) }
                  options={ [
                    {
                      "value": "csv",
                      "label": "CSV"
                    },
                    {
                      "value": "xlsx",
                      "label": "XLSX"
                    },
                    {
                      "value": "pdf",
                      "label": "PDF"
                    },

                  ] } />
              </Form.Item>

            </Col>
            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="email_receiver" label={ trans(`${langKey}.email_receiver`) } rules={ rules.email_receiver }

              >
                <SelectWithSearch
                  onChange={ (value) => {

                    setEmailReciver(value)

                  } }
                  placeholder={ trans(`${langKey}.email_receiver`) }
                  options={ emailRecievers } />
              </Form.Item>

            </Col>
            {
              emailReciver === 'manual' &&

              <>
                <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                  <Form.Item name="email_to" label={ trans(`${langKey}.emailto`) } rules={ rules.emailto }

                  >
                    <InputText

                      placeholder={ trans(`${langKey}.emailto`) }
                    />
                  </Form.Item>

                </Col>
                <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                  <Form.Item name="email_cc" label={ trans(`${langKey}.emailcc`) } rules={ rules.emailcc }
                  >
                    <InputText
                      placeholder={ trans(`${langKey}.emailcc`) }
                    />
                  </Form.Item>
                </Col>

              </>
            }

            {/* <Divider>Scheduling</Divider> */ }
            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="frequency" label={ trans(`${langKey}.frequency`) } rules={ rules.frequency }

              >
                <SelectWithSearch

                  onChange={ (value) => {
                    setFrequency(value)
                  } }
                  placeholder={ trans(`${langKey}.frequency`) }
                  options={ frequencyOptions } />
              </Form.Item>

            </Col>
            {
              frequency === 'weekly' &&
              <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                <Form.Item name="day_of_week" label={ trans(`${langKey}.day_of_week`) } rules={ rules.day_of_week }

                >
                  <SelectWithSearch

                    placeholder={ trans(`${langKey}.day_of_week`) }
                    options={ days } />
                </Form.Item>

              </Col>
            }

            {
              frequency === 'monthly' &&
              <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                <Form.Item name="day_of_month" label={ trans(`${langKey}.day_of_month`) } rules={ rules.day_of_month }

                >
                  <InputText
                    type="number"
                    min={ 1 }
                    max={ 31 }
                    placeholder={ trans(`${langKey}.day_of_month`) }
                    onWheel={ (e) => e.target.blur() } // Prevents scrolling the input value
                  />
                </Form.Item>

              </Col>
            }
            {
              frequency !== 'custom' && frequency &&
              <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                <Form.Item name="time_of_day" label={ trans(`${langKey}.time_of_day`) } rules={ rules.time_of_day }

                >
                  <InputTime />
                </Form.Item>

              </Col>
            }

            {
              frequency === 'custom' &&
              <Col lg={ 24 } sm={ 24 } xs={ 24 } >
                <Form.Item name="custom_cron_expression" label={ trans(`${langKey}.custom_cron_expression`) } rules={ rules.custom_cron_expression }

                >
                  <InputTextArea placeholder={ trans(`${langKey}.custom_cron_expression`) } />
                </Form.Item>

              </Col>
            }

            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="status" label={ trans(`${langKey}.status`) } rules={ rules.status }

              >
                <SelectWithSearch

                  placeholder={ trans(`${langKey}.status`) }
                  options={ [
                    {
                      "value": "active",
                      "label": "Active"
                    },
                    {
                      "value": "inactive",
                      "label": "Inactive"
                    }
                  ] } />
              </Form.Item>

            </Col>

            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="next_run_at" label={ trans(`${langKey}.next_run_at`) } rules={ rules.next_run_at }

              >
                <InputTime format="DD MMM YYYY hh:mm a" disabled />
              </Form.Item>

            </Col>
            <Col lg={ 24 } sm={ 24 } xs={ 24 } >
              <Form.Item name="last_run_at" label={ trans(`${langKey}.last_run_at`) } rules={ rules.last_run_at }

              >
                <InputTime format="DD MMM YYYY hh:mm a" disabled />
              </Form.Item>

            </Col>
          </Row>

        </Form>

      </Skeleton>

    </ModalComponent>
  )
}

export default ScheduleReport

const rules = {
  name: [
    { required: false, message: trans(`${langKey}.name.required`) },
  ],
  scheduled_ids: [
    { required: true, message: trans(`${langKey}.scheduled_ids`) },
  ],
  email_receiver: [
    { required: true, message: trans(`${langKey}.email_receiver`) },
  ],
  emailto: [
    { required: true, message: trans(`${langKey}.emailto`) },
  ],
  frequency: [
    { required: true, message: trans(`${langKey}.frequency`) },
  ],
  day_of_week: [
    { required: true, message: trans(`${langKey}.day_of_week`) },
  ],
  day_of_month: [
    { required: true, message: trans(`${langKey}.day_of_month`) },
  ],
  time_of_day: [
    { required: true, message: trans(`${langKey}.time_of_day`) },
  ],
  custom_cron_expression: [
    { required: true, message: trans(`${langKey}.custom_cron_expression`) },
  ],
  status: [
    { required: true, message: trans(`${langKey}.status`) },
  ],


};
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

